<template>
    <div class="auth-content">
        <div class="auth-modal">
            <img src="@/assets/logomsl.png" width="200" alt="Logo" />
            <hr>
            <input v-if="showSignup" v-model="user.name" type="text" placeholder="Nome">
            <input v-model="user.cpf" name="cpf" type="number" placeholder="Informe seu CPF">
            <input v-model="user.id_empresa" name="id_empresa" type="number" placeholder="Código da empresa">
            <input v-model="user.password" name="password" type="password" placeholder="Senha">
            <input v-if="showSignup" v-model="user.confirmPassword" type="password" placeholder="Confirme a Senha"> 

            <button v-if="showSignup" @click="signup">Registrar</button>
            <button v-else @click="signin">Entrar</button>
        </div>
    </div>
</template>

<script>
import { baseApiUrl, showError, userKey } from '@/global'
import axios from 'axios'

export default {
    name: 'Auth',
    data: function() {
        return {
            showSignup: false,
            user: {},
            cliente: {}
        }
    },
    methods: {
        signin() {

            axios.post(`${baseApiUrl}/signin`, this.user)                
                .then(res => {                                     
                    this.$store.commit('setUser', res.data)
                    localStorage.setItem(userKey, JSON.stringify(res.data))
                    this.$router.push({ path: '/' })
                    
                })
                .catch(showError)
        },
        signup() {
            axios.post(`${baseApiUrl}/signup`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.user = {}
                    this.showSignup = false
                    this.getTreeData()      
                })
                .catch(showError)
        },


    },

    mounted() {  
        
        //this.loadPermissao() 
        //this.loadMenu()
    },
}
</script>

<style>

    .auth-content {        
        height: 100%;     
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("https://s3.sa-east-1.amazonaws.com/erp.ml18.com.br/img/bus6.jpg"); 
        /*background-image: url("https://source.unsplash.com/random"); */
        /*https://s3.sa-east-1.amazonaws.com/erp.ml18.com.br/img/terminal_sacoma.jpg */
        /*background-image: url("https://via-sudeste.s3.sa-east-1.amazonaws.com/fundo_tela.jpeg");*/ 
        /*background-image: url("https://ml18cliente.s3.sa-east-1.amazonaws.com/aplicativos/fundo_tela.jpeg"); */
        background-size:cover;
        background-repeat:no-repeat;
    }

    .auth-modal {
        background-color: #FFF;
        border-radius: 4%;        
        width: 328px;
        padding: 35px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);

        display: flex;
        flex-direction: column;
        align-items: center;
    }
    /*
    .auth-title {
        font-size: 1.0rem;
        font-weight: 100;
        margin-top: 10px;
        margin-bottom: 15px;
    }
    */

    .auth-modal input {
        border: 1px solid #BBB;
        width: 100%;
        margin-bottom: 10px;
        padding: 3px 8px;
        /*outline: none;  retira a sombra do campo selecionado*/
    }

    .auth-modal button {
        align-self: flex-end;
        background-color: #2460ae;
        color: #FFF;
        padding: 5px 18px;
    }

    .auth-modal a {
        margin-top: 18px;
    }
</style>